import { render, staticRenderFns } from "./mktSwitch.vue?vue&type=template&id=00967e95&"
import script from "./mktSwitch.vue?vue&type=script&lang=js&"
export * from "./mktSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports